'use strict'

import Helper from '@/utils/helper'

class FiscalizationData {
  constructor({fiscalDriver, fiscalDocNumber, fpd, date}) {
    Helper.checkString('FiscalizationData.fiscalDriver', fiscalDriver)
    Helper.checkNonNegativeLong('FiscalizationData.fiscalDocNumber', fiscalDocNumber)
    Helper.checkString('FiscalizationData.fpd', fpd)
    Helper.checkString('FiscalizationData.date', date)

    this.fiscalDriver = fiscalDriver
    this.fiscalDocNumber = fiscalDocNumber
    this.fpd = fpd
    this.date = date
  }

  getFiscalDriver () {
    return this.fiscalDriver
  }

  getFiscalDocNumber () {
    return this.fiscalDocNumber
  }

  getFpd () {
    return this.fpd
  }

  getDate () {
    return this.date
  }

  toString() {
    return 'FiscalizationData{' +
      'fiscalDriver=' + '\'' + this.fiscalDriver + '\'' +
      ', fiscalDocNumber=' + '\'' + this.fiscalDocNumber + '\'' +
      ', fpd=' + '\'' + this.fpd + '\'' +
      ', date=' + '\'' + this.date + '\'' +
      '}'
  }
}

export default FiscalizationData
